import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-leases',
  imports: [],
  templateUrl: './admin-leases.component.html',
  styleUrl: './admin-leases.component.scss',
})
export class AdminLeasesComponent {

}
